module.exports = __webpack_public_path__ + "static/media/html.77e434ce.svg";